import React from 'react'
import { COLOR_TYPE_GRAY_TINT_9, ColorType } from 'src/utils/color'

import { CLASS_PREFIX } from 'src/constants'
import './public-participation-navigation-icon.scss'

type Props = {
  size?: number;
  color?: ColorType;
};

const cls = CLASS_PREFIX + 'public-participation-navigation-icon'

export const PublicParticipationNavigationIcon: React.FC<Props> = ({ size = 24, color = COLOR_TYPE_GRAY_TINT_9 }) => {
  return (
    <svg
      aria-hidden={true}
      className={`${cls}__fill ${cls}__fill--${color}`}
      xmlns="http://www.w3.org/2000/svg"
      height={`${size}px`}
      viewBox="0 -960 960 960"
      width={`${size}px`}
    >
      <path d="M880-80 720-240H320q-33 0-56.5-23.5T240-320v-40h440q33 0 56.5-23.5T760-440v-280h40q33 0 56.5 23.5T880-640v560ZM160-473l47-47h393v-280H160v327ZM80-280v-520q0-33 23.5-56.5T160-880h440q33 0 56.5 23.5T680-800v280q0 33-23.5 56.5T600-440H240L80-280Zm80-240v-280 280Z" />
    </svg>
  )
}
